/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {firestoreAction} from 'vuexfire';
import {db} from '@/firebaseConfig'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({commit}, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  // /////////////////////////////////////////////
  // deltaPOS
  // /////////////////////////////////////////////

  bindParameters: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('parameters', db.collection('parameters'));
  }),

  bindStock: firestoreAction(({bindFirestoreRef}, branchCode) => {
    return bindFirestoreRef('realtime', db.collection(branchCode));
  }),

  updateAppLoaded({commit}, value) {
    commit('UPDATE_APP_LOADED', value);
  },

  updateNavMenuItems({commit}, value) {
    commit('UPDATE_NAVMENUTITEMS', value);
  },

  // Cart updates
  toggleItemInCart({commit}, item) {
    commit('TOGGLE_ITEM_IN_CART', item)
  },
  additemInCart({commit}, item) {
    item["quantity"] = 1;
    item["discount"] = 0;
    item["amount"] = item["quantity"] * item["price"];
    item["cooking_instructions"] = '';
    commit('ADD_ITEM_IN_CART', item)
  },
  updateItemQuantity({commit}, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  updateItemDiscountPercent({commit}, payload) {
    commit('UPDATE_ITEM_DISCOUNT_PERCENT', payload)
  },
  updateItemDiscount({commit}, payload) {
    commit('UPDATE_ITEM_DISCOUNT', payload)
  },
  updatePaymentAmount({commit}, payload) {
    commit('UPDATE_PAYMENT_AMOUNT', payload)
  }
}

export default actions
